import React from 'react';

export const DiamondLoader = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-20 h-20',
    xl: 'w-24 h-24'
  };

  return (
    <div className={`relative ${sizeClasses[size]} ${className}`}>
      <style>{`
        @keyframes diamondRotate {
          0% {
            transform: rotateY(0deg);
          }
          100% {
            transform: rotateY(360deg);
          }
        }
        
        @keyframes diamondPulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.7;
            transform: scale(0.95);
          }
        }
        
        @keyframes sparkle1 {
          0%, 100% {
            opacity: 0;
            transform: scale(0) translate(0, 0);
          }
          50% {
            opacity: 1;
            transform: scale(1) translate(-5px, -5px);
          }
        }
        
        @keyframes sparkle2 {
          0%, 100% {
            opacity: 0;
            transform: scale(0) translate(0, 0);
          }
          50% {
            opacity: 1;
            transform: scale(1) translate(5px, -8px);
          }
        }
        
        @keyframes sparkle3 {
          0%, 100% {
            opacity: 0;
            transform: scale(0) translate(0, 0);
          }
          50% {
            opacity: 1;
            transform: scale(1) translate(8px, 3px);
          }
        }
        
        @keyframes shimmer {
          0% {
            opacity: 0.3;
          }
          50% {
            opacity: 0.8;
          }
          100% {
            opacity: 0.3;
          }
        }
        
        .diamond-container {
          animation: diamondPulse 2s ease-in-out infinite;
          perspective: 1000px;
        }
        
        .diamond-rotate {
          animation: diamondRotate 3s linear infinite;
          transform-style: preserve-3d;
        }
        
        .sparkle {
          position: absolute;
          width: 6px;
          height: 6px;
          background: #1a1a1a;
          border-radius: 50%;
        }
        
        .sparkle-1 {
          top: 5%;
          left: 20%;
          animation: sparkle1 1.5s ease-in-out infinite;
        }
        
        .sparkle-2 {
          top: 10%;
          right: 15%;
          animation: sparkle2 1.5s ease-in-out infinite 0.3s;
        }
        
        .sparkle-3 {
          top: 35%;
          right: 5%;
          animation: sparkle3 1.5s ease-in-out infinite 0.6s;
        }
        
        .facet-shimmer {
          animation: shimmer 1.5s ease-in-out infinite;
        }
      `}</style>
      
      <div className="diamond-container w-full h-full">
        {/* Sparkles */}
        <div className="sparkle sparkle-1"></div>
        <div className="sparkle sparkle-2"></div>
        <div className="sparkle sparkle-3"></div>
        
        {/* Diamond SVG */}
        <svg
          viewBox="0 0 100 100"
          className="w-full h-full diamond-rotate"
        >
          {/* Diamond outline */}
          <polygon
            points="50,8 90,35 50,92 10,35"
            fill="none"
            stroke="#1a1a1a"
            strokeWidth="2.5"
            strokeLinejoin="round"
          />
          
          {/* Crown (top part) */}
          <polygon
            points="50,8 90,35 10,35"
            fill="none"
            stroke="#1a1a1a"
            strokeWidth="2"
          />
          
          {/* Crown facets */}
          <line x1="50" y1="8" x2="30" y2="35" stroke="#1a1a1a" strokeWidth="1.5" />
          <line x1="50" y1="8" x2="70" y2="35" stroke="#1a1a1a" strokeWidth="1.5" />
          
          {/* Girdle line */}
          <line x1="10" y1="35" x2="90" y2="35" stroke="#1a1a1a" strokeWidth="2" />
          
          {/* Pavilion facets (bottom part) */}
          <line x1="30" y1="35" x2="50" y2="92" stroke="#1a1a1a" strokeWidth="1.5" className="facet-shimmer" />
          <line x1="50" y1="35" x2="50" y2="92" stroke="#1a1a1a" strokeWidth="1.5" />
          <line x1="70" y1="35" x2="50" y2="92" stroke="#1a1a1a" strokeWidth="1.5" className="facet-shimmer" style={{animationDelay: '0.5s'}} />
          
          {/* Inner shine effect */}
          <polygon
            points="50,20 65,35 50,70 35,35"
            fill="#1a1a1a"
            opacity="0.1"
            className="facet-shimmer"
          />
        </svg>
      </div>
    </div>
  );
};

export const DiamondLoaderWithText = ({ text = 'Loading...', size = 'lg' }) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <DiamondLoader size={size} />
      <p className="text-sm uppercase tracking-widest text-muted-foreground font-medium animate-pulse">
        {text}
      </p>
    </div>
  );
};
